import {DocumentInfo} from "../models/general/DocumentInfo.model";

/* tslint:disable */

export const DOCUMENTS: DocumentInfo[] = [
  {
    name: "Text Related to Sustainability Firings",
    link: "doc-archive/sustainability_1.jpg",
    description: "Texts sent to and from Connie Boesen and Scott Sanders containing the word sustainability between December 9, 2024 and January 9, 2025.",
    date: "2/21/25",
  },
  {
    name: "Email Related to Sustainability Firings",
    link: "doc-archive/sustainability_2.pdf",
    description: "Emails sent to and from Connie Boesen and Scott Sanders containing the word sustainability between December 9, 2024 and January 9, 2025.",    date: "2/21/25",
  },
  {
    name: "Sanders' Statement on Sustainability Firings",
    link: "doc-archive/01_13_2025_sandersStatement.pdf",
    description: "Written statement given by City Manager Sanders at a city council meeting regarding his firings of sustainability department employees.",
    date: "1/13/25",
  },
  {
    name: "Homelessness / Notice Period Before Announcement - agenda",
    link: "doc-archive/encroachment_notice/agenda.pdf",
    description: "Agenda for private meeting ahead of homeless policy change announcement.",
    date: "10/27/24",
  },
  {
    name: "Homelessness / Notice Period Before Announcement - expanded invite",
    link: "doc-archive/encroachment_notice/expanded_invite.pdf",
    description: "Expanded invite (more names, and agenda) to private meeting ahead of homeless policy change announcement.",
    date: "10/27/24",
  },
  {
    name: "Homelessness / Notice Period Before Announcement - initial invite",
    link: "doc-archive/encroachment_notice/initial_invite.pdf",
    description: "Initial invite to private meeting ahead of homeless policy change announcement.",
    date: "10/27/24",
  },
  {
    name: "Homlessness / Grant's Pass FOIA Part Four: Additional",
    link: "doc-archive/grantspass_produce_redacted.pdf",
    description: "One part of a FOIA concerning the sleeping ban.",
    date: "9/24/24",
  },
  {
    name: "Homlessness / Grant's Pass FOIA Part Three: Coleman Texts 2",
    link: "doc-archive/coleman-texts-homelessness2.png",
    description: "One part of a FOIA concerning the sleeping ban.",
    date: "9/24/24",
  },
  {
    name: "Homlessness / Grant's Pass FOIA Part Two: Coleman Texts 1",
    link: "doc-archive/coleman-texts-homelessness1.png",
    description: "One part of a FOIA concerning the sleeping ban.",
    date: "9/24/24",
  },
  {
    name: "Homlessness / Grant's Pass FOIA Part One: Coleman Emails",
    link: "doc-archive/coleman-email-homelessness.pdf",
    description: "One part of a FOIA concerning the sleeping ban.",
    date: "9/24/24",
  },
  {
    name: "City of Des Moines Secret Developer Meetings '23",
    link: "doc-archive/developer_meetings_23/developer_meeting_list.pdf",
    description: "The City's list of 25 secret developer meetings in 2023 from August 14 to October 6.",
    date: "4/29/24",
  },
  {
    name: "City of Des Moines Response to IPIB concerning 12/20 meeting",
    link: "doc-archive/dsm_ipib_1_10_24.pdf",
    description: "Response by the City of Des Moines to complaint from Adam Callanan through the IPIB.",
    date: "1/10/24",
  },
  {
    name: "21st Century Policing DMPD Review Report - some Sanders emails",
    link: "doc-archive/sanders_21centurypolicing_12-20-23.pdf",
    description: "any emails sent to Scott Sanders from August 1, 2023 to November 16, 2023 containing 21 Century Policing or 21CP.",
    date: "12/20/23",
  },
  {
    name: "21st Century Policing DMPD Review Report",
    link: "doc-archive/21centurypolicing-report.pdf",
    description: "21st Century Policing Report, concluding their review of DMPD. Seemingly withheld til after 2023 election.",
    date: "11/20/23",
  },
  {
    name: "Crow Tow Contract 2019",
    link: "doc-archive/crow-tow-contract-2019.pdf",
    description: "Crow Tow Contract from 2019.",
    date: "10/18/23",
  },
  {
    name: "Baker Tilly Summary - Governance 2023",
    link: "doc-archive/baker_tilly_final_summary_2023.pdf",
    description: "Final Summary from Baker Tilly concerning city council governance.",
    date: "05/23/23",
  },
  {
    name: "Baker Tilly Contract - Council Governance 2023",
    link: "doc-archive/baker_tilly_contract_2023.pdf",
    description: "Contract with Baker Tilly concerning city council governance.",
    date: "05/23/23",
  },
  {
    name: "Des Moines City Council Governance Notes - Voss",
    link: "doc-archive/05_23_23_voss-notes.pdf",
    description: "Notes from meeting concerning city council governance.",
    date: "05/23/23",
  },
  {
    name: "Des Moines City Council Governance Notes - Gatto",
    link: "doc-archive/05_23_23_gatto-notes.JPG",
    description: "Notes from meeting concerning city council governance.",
    date: "05/23/23",
  },
  {
    name: "Des Moines City Council Governance Workshop Docs",
    link: "doc-archive/05_23_23_worksheet_docs.pdf",
    description: "Worksheet from agenda-less public meeting concerning city council governance.",
    date: "05/23/23",
  },
  {
    name: "Riverview Park Statement: Hip-Hop Banned",
    link: "doc-archive/riverview-park-statement.pdf",
    description: "Statement from Tanner Briggs Faaborg concerning Des Moines Council Member Linda Westergaard and Polk County Supervisor Tom Hockensmith calling to ban hip-hop at the public Riverview Park.",
    date: "11/30/22",
  },
  {
    name: "Roe Record Request: Cownie Pt 1",
    link: "doc-archive/2022-10-22_ACTIONALERTRoeVWade_Redacted.pdf",
    description: "Part 1 of 4 related to a record request for Mayor Cownie's emails from June 1, 2022 to October 6, 2022 about roe/abortion. Costed $185.18 for 4.5 hours. ",
    date: "10/22/22",
  },
  {
    name: "Roe Record Request: Cownie Pt 2",
    link: "doc-archive/2022-10-22_DemocraticMayorsNewsletterRoeVWadeAndMore_Redacted.pdf",
    description: "Part 2 of 4 related to a record request for Mayor Cownie's emails from June 1, 2022 to October 6, 2022 about roe/abortion. Costed $185.18 for 4.5 hours. ",
    date: "10/22/22",
  },
  {
    name: "Roe Record Request: Cownie Pt 3",
    link: "2022-10-22_DemocraticMayorsStatementOnTheSupremeCourtOverturnRoevWade_Redacted.pdf",
    description: "Part 3 of 4 related to a record request for Mayor Cownie's emails from June 1, 2022 to October 6, 2022 about roe/abortion. Costed $185.18 for 4.5 hours. ",
    date: "10/22/22",
  },
  {
    name: "Roe Record Request: Cownie Pt 4",
    link: "2022-10-22_RoeRecordRequestProduce.pdf",
    description: "Part 4 of 4 related to a record request for Mayor Cownie's emails from June 1, 2022 to October 6, 2022 about roe/abortion. Costed $185.18 for 4.5 hours. ",
    date: "10/22/22",
  },
  {
    name: "Sheumaker Countersuit against DMPD Officers",
    link: "doc-archive/cops-v-residents-counter-complaint.pdf",
    description: "Sheumaker is countersuing two DMPD officers who are suing her. Full article: https://www.desmoinesregister.com/story/news/crime-and-courts/2022/08/17/des-moines-city-council-indira-sheumaker-counterclaim-police-protest-arrest/10341748002/?utm_source=newsletter&utm_medium=email&utm_campaign=newsletter_axioslocal_desmoines&stream=top",
    date: "08/17/22",
  },
  {
    name: "DMPD Officers Suing Residents over Protests",
    link: "doc-archive/cops-v-residents-complaint.pdf",
    description: "Two DMPD officers are suing Councillor Sheumaker and other residents over a 2020 protest. Full article: https://www.desmoinesregister.com/story/news/crime-and-courts/2022/07/06/des-moines-city-council-indira-sheumaker-sued-police-officers-george-floyd-protests-2020/7820683001/",
    date: "07/06/22",
  },
  {
    name: "Complaint Against Iowa City Fire Department",
    link: "doc-archive/complaint-against-iowa-city-fire-department.pdf",
    description: "Female Iowa City firefighter files lawsuit alleging discrimination and harassment. Full article: https://www.thegazette.com/local-government/female-iowa-city-firefighter-files-lawsuit-alleging-discrimination-and-harassment/",
    date: "08/03/22",
  },
  {
    name: "Mandelbaum's Draft Resolution in Response to Roe's Overturn",
    link: "doc-archive/mandelbaum-roe-draft.pdf",
    description: "Draft of abortion protection resolution from Councillor Mandelbaum, provided via Axios. Full article: https://www.axios.com/local/des-moines/2022/08/10/abortion-investigations-would-be-prohibited-under-des-moines-proposal",
    date: "08/10/22",
  },
  {
    name: "Law Enforcement Data Project",
    link: "doc-archive/law_enforcement_report_04-21-22.pdf",
    description: "Report from Public Works, LLC on Law Enforcement Data.",
    date: "04/27/22",
  },
  {
    name: "Code Enforcement Data Project",
    link: "doc-archive/code_enforcement_report_04-21-22.pdf",
    description: "Report from Public Works, LLC on Code Enforcement Data.",
    date: "04/27/22",
  },
  {
    name: "Law and Code Enforcement Data Project: Presentation",
    link: "doc-archive/law_enforcement_data_report_4-27-22.pdf",
    description: "Presentation from Public Works, LLC on Law & Code Enforcement Data.",
    date: "04/27/22",
  },
  {
    name: "Remarks on DMPD Consultants",
    link: "view/markdown~04_18_22_cownie-statement-dmpd",
    useHost: true,
    description: "Remarks made by Mayor Frank Cownie on 4/18/22 in response to community calls for action on DMPD.",
    date: "04/18/22",
  },
  {
    name: "BLM x PTH: George Flagg Parkway Statement",
    link: "doc-archive/BLMXPTH_GeorgeFlaggParkway_statement.pdf",
    description: "Statement from BLM and PTH on the effort to Rename George Flagg Parkway.",
    date: "04/07/22",
  },
  {
    name: "DSM Council Meeting Notes",
    link: "meeting-notes/council/04_04_22_regular-meeting.pdf",
    description: "Meeting Notes from the 4/4/22 Regular Council Meeting.",
    date: "04/04/22",
  },
  {
    name: "3/16/22 Family of George Flagg Email to City Council Members other than Indira",
    link: "doc-archive/2022_03_16_flagg_email.pdf",
    description: "Email from the family of George Flagg to City Council Members calling for retention of George Flagg's street name. Council Member Indira Sheumaker, the only Black council person, was excluded.",
    date: "3/16/22",
  },
  {
    name: "3/9/22 PTH x NDMMA Mutual Aid 101 Notes",
    link: "meeting-notes/pth-event/03_09_22_mutual_aid_101_notes.pdf",
    description: "Notes from PTH x NDMMA Mutual Aid 101 event on 3/9/22.",
    date: "3/9/22",
  },
  {
    name: "DSM Council Meeting Notes",
    link: "meeting-notes/council/03_07_22_regular-meeting.pdf",
    description: "Meeting Notes from the 3/7/22 Regular Council Meeting.",
    date: "03/07/22",
  },
  {
    name: "3/2/22 PTH Notes",
    link: "meeting-notes/pth-event/03_02_22_notes.pdf",
    description: "Notes from PTH event on 3/2/22.",
    date: "3/2/22",
  },
  {
    name: "Remarks on Campaign Donor Conflict of Interest",
    link: "view/markdown~02_21_22_legal_opinion",
    useHost: true,
    description: "Remarks made by Mayor Frank Cownie on 2/21/22.",
    date: "02/21/22",
  },
  {
    name: "DSM Council Meeting Notes",
    link: "meeting-notes/council/02_21_22_regular-meeting.pdf",
    description: "Meeting Notes from the 2/21/22 Regular Council Meeting.",
    date: "02/21/22",
  },
  {
    name: "Constituent Notes on Consent Agenda",
    link: "doc-archive/02_07_22_consent_notes.pdf",
    description: "Consent Agenda Notes submitted by constituents for the 2/21/22 council meeting.",
    date: "02/21/22",
  },
  {
    name: "Fiscal Year 2023 Initial Budget Presentation",
    link: "doc-archive/FY2023_initial_budget_presentation.pdf",
    description: "Presentation on the Fiscal Year (FY) 2023 Budget from the 2/9/22 Budget Workshop.",
    date: "02/09/22",
  },
  {
    name: "DSM Council Meeting Notes",
    link: "meeting-notes/council/02_07_22_regular-meeting.pdf",
    description: "Meeting Notes from the 2/7/22 Regular Council Meeting.",
    date: "02/07/22",
  },
  {
    name: "Constituent Notes on Consent Agenda",
    link: "doc-archive/02_07_22_consent_notes.pdf",
    description: "Consent Agenda Notes submitted by constituents and read by Council Member Indira Sheumaker at the 2/7/22 council meeting.",
    date: "02/07/22",
  },
  {
    name: "Making Your Voice Heard Event Notes",
    link: "meeting-notes/pth-event/01_27_22_making-your-voice-heard.pdf",
    description: "Event Notes from the 1/27/22 People's Town Hall Event: Making Your Voice Heard.",
    date: "01/27/22",
  },
  {
    name: "DSM Council Meeting Notes",
    link: "meeting-notes/council/01_24_22_regular-meeting.pdf",
    description: "Meeting Notes from the 1/24/22 Regular Council Meeting.",
    date: "01/24/22",
  },
  {
    name: "Constituent Notes on DMPD",
    link: "doc-archive/01_24_22_consent_notes.pdf",
    description: "Consent Agenda Notes submitted by constituents and read by Council Member Indira Sheumaker at the 1/24/22 council meeting.",
    date: "01/24/22",
  },
  {
    name: "Emergency Winter Conditions & Unhoused Population",
    link: "doc-archive/Emergency_Winter_Conditons_and_Unhoused_Population.pdf",
    description: "Document submitted by Council Member Indira Sheumaker at the 1/14/22 special council meeting.",
    date: "01/14/22",
  },
  {
    name: "Performance Memo 2021",
    link: "doc-archive/performance_memo_2021.pdf",
    description: "A memo about city performance metrics.",
    date: "06/02/21",
  },
  {
    name: "Food Security Task Force Report",
    link: "doc-archive/2021_10_27_foodsecuritytaskforcereport.pdf",
    description: "The final report of the DSM Food Security Task Force.",
    date: "10/27/21",
  },
  {
    name: "Resolution from 08/09/21 on Retaining Outside Counsel",
    link: "doc-archive/2021-08-09_outside_counsel.pdf",
    description: "On August 9, 2021, DSM Council approved using outside counsel through Hopkins & Huebner, P.C.",
    date: "08/09/21",
  },
  {
    name: "Court Document for the Petition against DMPD on Discrimination",
    link: "doc-archive/sex-discrimination-case-dmpd.pdf",
    description: "A court document for petition against DMPD on Discrimination, as of 9-28-21. Contributed by the Des Moines Register.",
    date: "09/29/21",
  },
  {
    name: "DSM PTH Statement on July 19, 2021 Council Meeting",
    link: "doc-archive/council-meeting-7-19-21.pdf",
    description: "A statement on DSM Council's escalation of violence on critical speech.",
    date: "07/21/21",
  },
  {
    name: "DSM PTH Statement on Accessibility & Retaliation 07/12/21",
    link: "doc-archive/statement_071221.pdf",
    description: "A statement on the escalating attacks on accessibility to local government in Des Moines.",
    date: "07/12/21",
  },
  {
    name: "DMPS Student Resource Officer Report",
    link: "doc-archive/sro-report.pdf",
    description: "A report on Student Resource Officers (SROs) in schools. This was presented to Des Moines Public Schools who went on to remove SROs from schools.",
    date: "01/22/21",
  },
  {
    name: "Marijuana Task Force Recommendations / Report",
    link: "doc-archive/mtf-report.pdf",
    description: "The final report from the 2020 DSM Marijuana Task Force.",
    date: "11/09/20",
  },
  {
    name: "DMPD Gold Braid Union Threatening Letter",
    link: "doc-archive/gold-braid-letter.pdf",
    description: "Threatening letter sent by a DMPD cop 'union' to Council after Josh Mandelbaum raised questions about DMPD Conduct. Includes lies and references to stories that never happened.",
    date: "08/26/20",
  },
  {
    name: "EMAIL: Police Union vs Policy Change",
    link: "doc-archive/email3.pdf",
    description: "Email between Stewart Barnes (from DMPD Bargainin Unit Union), Joe Gatto (Council Member) and others about the council meetings and policy proposals.",
    date: "sent on 06/08/20",
  },
  {
    name: "EMAIL: Sanders to Clergy",
    link: "doc-archive/email2.pdf",
    description: "Sanders responds to an email about DMPD Brutality in a rage.",
    date: "sent on 08/23/20",
  },
  {
    name: "EMAIL: Dana Wingert to council about registered speakers",
    link: "doc-archive/email1.pdf",
    description: "Dana Wingert sent an email to council proactively going through the names of people signed up to speak at City Council meetings, highlighting profanity and political beliefs as well as surveilling their social media.",
    date: "sent 07/31/20",
  },
];
